import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=245ae1d7&scoped=true&"
import script from "./VideoMonitor.vue?vue&type=script&lang=js&"
export * from "./VideoMonitor.vue?vue&type=script&lang=js&"
import style0 from "./VideoMonitor.vue?vue&type=style&index=0&id=245ae1d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ae1d7",
  null
  
)

export default component.exports